import React, { useRef,useEffect, useState } from "react";
import "./CSS/MaintenanceScreen.css";
import { styled, useTheme } from "@mui/material/styles";
import Drawer from "@mui/material/Drawer";
import CssBaseline from "@mui/material/CssBaseline";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { useUser } from "./Context/UserContext";
import axios from "axios";
import Button from "@mui/material/Button";
import { pink, deepPurple } from "@mui/material/colors";
import { Alert, Snackbar } from "@mui/material";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Switch,  
  Tabs,
  Tab,
} from "@mui/material";
import {
  Card,
  CardContent,
  CardHeader,
  Grid,
  TextField,
  Box,
  Chip,
  Paper,
  Select,
  MenuItem,
  Backdrop,
  CircularProgress,
  FormControl, 
  InputLabel
} from "@mui/material";

import { 
  Container, 
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import dayjs from "dayjs";
import 'dayjs/locale/tr';
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

import SearchIcon from "@mui/icons-material/Search";
import InputAdornment from "@mui/material/InputAdornment";
import SecurityIcon from '@mui/icons-material/Security';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import StoreIcon from '@mui/icons-material/Store';
import LinkIcon from '@mui/icons-material/Link';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import ReceiptIcon from '@mui/icons-material/Receipt';
import PaymentsIcon from '@mui/icons-material/Payments';

import { useNavigate } from "react-router-dom";
import Avatar from "@mui/material/Avatar"; 
import { te } from "date-fns/locale";
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { toast } from 'react-toastify';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import DownloadIcon from '@mui/icons-material/Download';
import { Checkbox } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import * as XLSX from "xlsx";

const drawerWidth = 240;

const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })(
  ({ theme }) => ({
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: `-${drawerWidth}px`,
    variants: [
      {
        props: ({ open }) => open,
        style: {
          transition: theme.transitions.create("margin", {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
          }),
          marginLeft: 0,
        },
      },
    ],
  })
);

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme }) => ({
  transition: theme.transitions.create(["margin", "width"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  variants: [
    {
      props: ({ open }) => open,
      style: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: `${drawerWidth}px`,
        transition: theme.transitions.create(["margin", "width"], {
          easing: theme.transitions.easing.easeOut,
          duration: theme.transitions.duration.enteringScreen,
        }),
      },
    },
  ],
}));

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: "flex-end",
}));

const MaintenanceScreen = () => {

  let status = "1";
  let path =
    status === "0" ? "http://localhost:3003" : "https://outlettee.com:3003";
 const navigate = useNavigate();
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);
  const [selectedMenu, setSelectedMenu] = useState("");
  const [userInfos, setUserInfos] = useState([]);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("success");
  const { user } = useUser();

  useEffect(() => {
    const fetchShopData = async () => {
      try {
        const response = await axios.post(path + "/api/usersAuthInfos", {
          UserID: user?.ID
        });
        
        const parsedData = response.data;
        setUserInfos(parsedData); 
      } catch (error) {
        console.error("Error fetching shop data:", error);
      }
    };

    fetchShopData();
  }, []);

  
  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };
  const handleMenuClick = (menu) => {
    setSelectedMenu(menu); // Menü tıklamalarını yakala
  };

  const PinkSwitch = styled(Switch)(({ theme }) => ({
    "& .MuiSwitch-switchBase.Mui-checked": {
      color: pink[600],
      "&:hover": {
        backgroundColor: "rgba(233, 30, 99, 0.08)",
      },
    },
    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
      backgroundColor: pink[600],
    },
  }));

  const LightPurpleSwitch = styled(Switch)(({ theme }) => ({
    "& .MuiSwitch-switchBase.Mui-checked": {
      color: "#5d4037", // Açık mor renk
      "&:hover": {
        backgroundColor: "rgba(205, 220, 57, 0.08)", // Hover rengi
      },
    },
    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
      backgroundColor: "#795548", // Track rengi
    },
  }));
  const LimeGreenSwitch = styled(Switch)(({ theme }) => ({
    "& .MuiSwitch-switchBase.Mui-checked": {
      color: "#cddc39", // Fıstık yeşili
      "&:hover": {
        backgroundColor: "rgba(205, 220, 57, 0.08)", // Hover rengi
      },
    },
    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
      backgroundColor: "#cddc39", // Track rengi
    },
  }));

  const AUTH_CASE_MAP = {
  Status: "0",
  isAdmin: "1",
  DesignConverter: "2",
  DesignAdmin: "3",
  TradeMark: "4",
  UserEffort: "5",
  ShopEffort: "6",
  Reports: "7",
  ReportAdmin: "8",
  UbertySecondDatabase: "9",
  DesignResponsible: "10",
};
const DATABASE_OPTIONS = [
  { label: "Uberty", value: "UBERTY" },
  { label: "Dış Shop", value: "UBERTYSEC" },
  { label: "Kiralık Shop", value: "UBERTYTHIRD" },
];

const UserStatusTable = () => {
  const tableContainerRef = useRef(null);
  const [pendingChanges, setPendingChanges] = useState({});
  const [isSaving, setIsSaving] = useState(false);
  const [activeTab, setActiveTab] = useState(0);

  if (!userInfos) return null;

  // Switch'in ekranda görünen değeri (pending varsa onu göster)
  const getSwitchValue = (user, authType) => {
    const changeKey = `${user.UserID}-${authType}`;
    if (pendingChanges[changeKey]) {
      return pendingChanges[changeKey].newStatus === 1;
    }
    return user[authType] === 1;
  };

  // Switch tıklandığında
  const handleAuthChange = (userID, authType) => {
    const user = userInfos.find((u) => u.UserID === userID);
    const currentDisplayValue = getSwitchValue(user, authType);
    const newStatus = currentDisplayValue ? 0 : 1;
    const originalValue = user[authType] === 1 ? 1 : 0;

    // Yeni değer orijinalle aynıysa pending'den kaldır (kullanıcı geri aldı)
    if (newStatus === originalValue) {
      setPendingChanges((prev) => {
        const copy = { ...prev };
        delete copy[`${userID}-${authType}`];
        return copy;
      });
      return;
    }

    // caseNumber'ı map'ten al
    setPendingChanges((prev) => ({
      ...prev,
      [`${userID}-${authType}`]: {
        userID,
        authType,       // frontend field adı: "Status", "isAdmin", vb.
        newStatus,       // 0 veya 1
        caseNumber: AUTH_CASE_MAP[authType], // backend case numarası: "0", "1", vb.
      },
    }));
  };

  // Tüm bekleyen değişiklikleri API'ye gönder
  const handleSaveAll = async () => {
    if (Object.keys(pendingChanges).length === 0) {
      toast.info("Değişiklik yok!", { autoClose: 1500 });
      return;
    }

    setIsSaving(true);
    const changes = Object.values(pendingChanges);
    let successCount = 0;
    let errorCount = 0;

    try {
      await Promise.all(
        changes.map(async (change) => {
          try {
            // Backend'e: UserID, Status (0/1), authType (case numarası)
            await axios.post(path + "/api/updateAuthType", {
              UserID: change.userID,
              Status: change.newStatus,
              authType: change.caseNumber,
            });

            // Başarılı → local state güncelle
            setUserInfos((prev) =>
              prev.map((user) =>
                user.UserID === change.userID
                  ? { ...user, [change.authType]: change.newStatus }
                  : user
              )
            );
            successCount++;
          } catch (error) {
            console.error("Update error:", error);
            errorCount++;
          }
        })
      );

      if (errorCount === 0) {
        toast.success(`${successCount} yetki başarıyla güncellendi!`, {
          position: "bottom-right",
          autoClose: 2000,
        });
      } else {
        toast.warning(
          `${successCount} başarılı, ${errorCount} başarısız!`,
          { position: "bottom-right", autoClose: 3000 }
        );
      }

      setPendingChanges({});
    } catch (error) {
      toast.error("Güncellemede hata oluştu!", {
        position: "bottom-right",
      });
    } finally {
      setIsSaving(false);
    }
  };

  const handleCancelChanges = () => {
    setPendingChanges({});
    toast.info("Değişiklikler iptal edildi", { autoClose: 1500 });
  };

 const handleDatabaseChange = async (userID, newDatabaseName) => {
  try {
    await axios.post(path + "/api/updateDatabaseType", {
      UserID: userID,
      DatabaseName: newDatabaseName,
    });

    setUserInfos((prev) =>
      prev.map((user) =>
        user.UserID === userID
          ? { ...user, DatabaseName: newDatabaseName }
          : user
      )
    );

    toast.success("Database başarıyla güncellendi!", {
      position: "bottom-right",
      autoClose: 2000,
    });
  } catch (error) {
    console.error("Database update error:", error);
    toast.error("Database güncellenirken hata oluştu!", {
      position: "bottom-right",
    });
  }
};

  const hasPendingChanges = Object.keys(pendingChanges).length > 0;

  // Tab filtreleme - sadece DB'deki orijinal Status'a bak (pending ile tab değişmez)
  const activeCount = userInfos.filter((u) => u.Status === 1).length;
  const passiveCount = userInfos.length - activeCount;
  const filteredUsers = userInfos.filter((user) =>
    activeTab === 0 ? user.Status === 1 : user.Status !== 1
  );

  // Pending değişiklik olan satırları vurgula
  const hasRowChange = (userID) => {
    return Object.keys(pendingChanges).some((key) =>
      key.startsWith(`${userID}-`)
    );
  };

  const renderTableBody = () => {
    if (filteredUsers.length === 0) {
      return (
        <TableRow>
          <TableCell colSpan={13} align="center" sx={{ py: 4 }}>
            <Typography color="text.secondary">
              {activeTab === 0
                ? "Aktif kullanıcı bulunamadı"
                : "Pasif kullanıcı bulunamadı"}
            </Typography>
          </TableCell>
        </TableRow>
      );
    }

    return filteredUsers.map((user) => (
      <TableRow
        key={user.UserID}
        sx={{
          backgroundColor: hasRowChange(user.UserID)
            ? "#fff8e1 !important"
            : undefined,
        }}
      >
        <TableCell>{user.Username}</TableCell>
        <TableCell>{user.Email}</TableCell>
        <TableCell>
          <Switch
            checked={getSwitchValue(user, "Status")}
            onChange={() => handleAuthChange(user.UserID, "Status")}
            color="primary"
          />
        </TableCell>
        <TableCell>
          <Switch
            checked={getSwitchValue(user, "isAdmin")}
            onChange={() => handleAuthChange(user.UserID, "isAdmin")}
            color="secondary"
          />
        </TableCell>
        <TableCell>
          <LightPurpleSwitch
            checked={getSwitchValue(user, "DesignConverter")}
            onChange={() => handleAuthChange(user.UserID, "DesignConverter")}
          />
        </TableCell>
        <TableCell>
          <Switch
            checked={getSwitchValue(user, "DesignResponsible")}
            onChange={() => handleAuthChange(user.UserID, "DesignResponsible")}
            color="warning"
          />
        </TableCell>
        <TableCell>
          <Switch
            checked={getSwitchValue(user, "DesignAdmin")}
            onChange={() => handleAuthChange(user.UserID, "DesignAdmin")}
            color="secondary"
          />
        </TableCell>
        <TableCell>
          <Switch
            checked={getSwitchValue(user, "TradeMark")}
            onChange={() => handleAuthChange(user.UserID, "TradeMark")}
            color="error"
          />
        </TableCell>
        <TableCell>
          <LimeGreenSwitch
            checked={getSwitchValue(user, "UserEffort")}
            onChange={() => handleAuthChange(user.UserID, "UserEffort")}
          />
        </TableCell>
        <TableCell>
          <Switch
            checked={getSwitchValue(user, "ShopEffort")}
            onChange={() => handleAuthChange(user.UserID, "ShopEffort")}
            color="success"
          />
        </TableCell>
        <TableCell>
          <PinkSwitch
            checked={getSwitchValue(user, "Reports")}
            onChange={() => handleAuthChange(user.UserID, "Reports")}
          />
        </TableCell>
        <TableCell>
          <PinkSwitch
            checked={getSwitchValue(user, "ReportAdmin")}
            onChange={() => handleAuthChange(user.UserID, "ReportAdmin")}
          />
        </TableCell>
       <TableCell>
          <FormControl size="small" sx={{ minWidth: 120 }}>
            <Select
              value={user.DatabaseName || "UBERTY"}
              onChange={(e) => handleDatabaseChange(user.UserID, e.target.value)}
              sx={{ fontSize: "0.875rem" }}
            >
              {DATABASE_OPTIONS.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </TableCell>
      </TableRow>
    ));
  };

  return (
    <>
      {/* Kaydet / İptal */}
      {hasPendingChanges && (
        <Box
          sx={{
            position: "sticky",
            top: 0,
            zIndex: 1000,
            backgroundColor: "#fff3cd",
            padding: "12px",
            margin: "auto",
            maxWidth: "80%",
            borderRadius: "8px 8px 0 0",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
          }}
        >
          <Typography variant="body1" sx={{ fontWeight: "bold" }}>
            {Object.keys(pendingChanges).length} değişiklik bekliyor
          </Typography>
          <Box sx={{ display: "flex", gap: 2 }}>
            <Button
              variant="outlined"
              color="error"
              onClick={handleCancelChanges}
              disabled={isSaving}
            >
              İptal
            </Button>
            <Button
              variant="contained"
              color="success"
              onClick={handleSaveAll}
              disabled={isSaving}
              startIcon={isSaving ? <CircularProgress size={20} /> : null}
            >
              {isSaving ? "Kaydediliyor..." : "Tümünü Kaydet"}
            </Button>
          </Box>
        </Box>
      )}

      {/* Tabs */}
      <Box sx={{ maxWidth: "80%", margin: "auto" }}>
        <Tabs
          value={activeTab}
          onChange={(e, newValue) => setActiveTab(newValue)}
          sx={{
            backgroundColor: "#405D72",
            borderRadius: hasPendingChanges ? "0" : "8px 8px 0 0",
            "& .MuiTab-root": {
              color: "rgba(255,255,255,0.7)",
              fontWeight: "bold",
              "&.Mui-selected": {
                color: "#fff",
              },
            },
            "& .MuiTabs-indicator": {
              backgroundColor: "#4CAF50",
              height: 3,
            },
          }}
        >
          <Tab
            label={
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                Aktif Kullanıcılar
                <Chip
                  label={activeCount}
                  size="small"
                  sx={{
                    backgroundColor:
                      activeTab === 0 ? "#4CAF50" : "rgba(255,255,255,0.3)",
                    color: "#fff",
                    fontWeight: "bold",
                    height: 22,
                  }}
                />
              </Box>
            }
          />
          <Tab
            label={
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                Pasif Kullanıcılar
                <Chip
                  label={passiveCount}
                  size="small"
                  sx={{
                    backgroundColor:
                      activeTab === 1 ? "#f44336" : "rgba(255,255,255,0.3)",
                    color: "#fff",
                    fontWeight: "bold",
                    height: 22,
                  }}
                />
              </Box>
            }
          />
        </Tabs>
      </Box>

      {/* Tablo */}
      <TableContainer
        ref={tableContainerRef}
        component={Paper}
        sx={{
          maxWidth: "80%",
          maxHeight: "80vh",
          overflowY: "auto",
          margin: "auto",
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
          borderRadius: "0 0 8px 8px",
        }}
      >
        <Table
          sx={{
            width: "100%",
            "& th": {
              backgroundColor: "#405D72",
              color: "white",
              fontWeight: "bold",
              position: "sticky",
              top: 0,
              zIndex: 2,
            },
            "& td": {
              padding: "12px",
            },
            "& tr:nth-of-type(even)": {
              backgroundColor: "#f5f5f5",
            },
            "& tr:hover": {
              backgroundColor: "#e0f7fa",
            },
          }}
        >
          <TableHead>
            <TableRow>
              <TableCell>Kullanıcı Adı</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>Aktiflik Durumu</TableCell>
              <TableCell>Adminlik Durumu</TableCell>
              <TableCell>Dizayn Dönüştürme</TableCell>
              <TableCell>Dizayn Düzenleme</TableCell>
              <TableCell>Dizayn Admin</TableCell>
              <TableCell>Trademark</TableCell>
              <TableCell>Kullanıcı Efor</TableCell>
              <TableCell>Shop Efor</TableCell>
              <TableCell>Raporlar</TableCell>
              <TableCell>Rapor Düzenleme Yetkisi</TableCell>
              <TableCell>Dış Shop Kullanıcısı</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>{renderTableBody()}</TableBody>
        </Table>
      </TableContainer>
    </>
  );
};



  const [shopdata, setShopData] = useState([]);
  const [userData, setUserData] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [userShops, setUserShops] = useState({});
  console.log(shopdata);
  useEffect(() => {
    const fetchShopData = async () => {
      try {
        const response = await axios.post(
          path + "/api/GetShopData",
          {
            UserID: user?.ID
          },
          {
            headers: {
              "Content-Type": "application/json"
            }
          }
        );

        const parsedData = response.data;
        setShopData(parsedData); // Set the fetched data to shopData state
      } catch (error) {
        console.error("Error fetching shop data:", error);
      }
    };

    fetchShopData();

    const fetchUserData = async () => {
      try {
        const response = await axios.post(path + "/api/GetUserData",{
          UserID: user?.ID,
        }); 

     
        const parsedData = response.data;
        setUserData(parsedData); // Set the fetched data to shopData state
      } catch (error) {
        console.error("Error fetching shop data:", error);
      }
    };

    fetchUserData();
  }, []);

  useEffect(() => {
    if (!selectedUser) return;

    // Backend'e istek: { UserID: selectedUser.UserID }
    const fetchUserShops = async () => {
      console.log(selectedUser.UserID);
      try {
        const response = await axios.post(path + "/api/getUserShops", {
          UserID: selectedUser.UserID,
        });

        const rows = response.data.data;
        if (Array.isArray(rows)) {
          // Aşağıda userShops'ı güncellemek için ShopID'leri çekiyoruz
          const shopIDs = rows.map((row) => row.ShopID);

          // userShops state'i => { [UserID]: [ShopIDs], ... }
          setUserShops((prev) => ({
            ...prev,
            [selectedUser.UserID]: shopIDs,
          }));
        }
      } catch (error) {
        console.error("Error fetching user shops:", error);
      }
    };

    fetchUserShops();
  }, [selectedUser]);

  const saveUserShops = async () => {
    if (!selectedUser) return;
  
    const selectedShopIds = userShops[selectedUser.UserID] || [];
  
    const assignments = selectedShopIds.map((shopId) => {
      const shop = shopdata.find((s) => s.ID === shopId);
      return {
        ShopName: shop?.ShopName ?? "Unknown",
        ShopID: shop?.ID ?? 0,
        UserID: selectedUser.UserID,
        UserName: selectedUser.UserName,
        Status: true,
      };
    });
  
    const payload = {
      userId: selectedUser.UserID,
      assignments: assignments, // Bu dizi boş olabilir.
    };
  
    try {
      console.log("Payload to save:", selectedUser.UserID);
     await axios.post(`${path}/api/saveUserShops`, {
        UserID: user?.ID,
        selectedUserID: selectedUser.UserID,
        payload: assignments
      });
      alert("Seçili kullanıcı mağazaları başarıyla kaydedildi!");
    } catch (error) {
      console.error("Save error:", error);
      alert("Kayıt sırasında hata oluştu.");
    }
  };

  const UserShopMatch = ({ userData, shopData }) => {
    const [searchUser, setSearchUser] = useState("");
    const [searchShop, setSearchShop] = useState("");

    const handleShopAssignment = (shopId) => {
      if (!selectedUser) return;

      setUserShops((prev) => ({
        ...prev,
        [selectedUser.UserID]: prev[selectedUser.UserID]
          ? prev[selectedUser.UserID].includes(shopId)
            ? prev[selectedUser.UserID].filter((id) => id !== shopId)
            : [...prev[selectedUser.UserID], shopId]
          : [shopId],
      }));
    };

    // Kullanıcıları filtreliyoruz
    const filteredUsers = userData.filter(
      (user) =>
        user.UserName.toLowerCase().includes(searchUser.toLowerCase()) ||
        user.Email.toLowerCase().includes(searchUser.toLowerCase())
    );

    // Mağazaları filtreliyoruz
    const filteredShops = shopData.filter((shop) =>
      shop.ShopName.toLowerCase().includes(searchShop.toLowerCase())
    );

    return (
      <Box
        sx={{
          p: 3,
          maxWidth: "90%",
          margin: "0 auto",
          maxHeight: "80vh",
          backgroundColor: "rgb(203, 214, 214)",
          overflow: "auto",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center", // Çok satırlı metinler için ortalama
            marginBottom: 2, // Alt boşluk (opsiyonel)
          }}
        >
          <Typography variant="h4" gutterBottom>
            Mağaza Yönetim Paneli
          </Typography>
        </Box>
        {/* 3 Card'ı yan yana göstermek için aynı Grid container içinde 3 Grid item kullanıyoruz */}
        <Grid container spacing={3}>
          {/* 1. Card: Kullanıcılar Listesi */}
          <Grid item xs={12} md={4}>
            <Card elevation={3}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: 1,
                  p: 2,
                  overflow: "auto",
                  maxHeight: "80vh",
                }}
              >
                <Typography variant="h6" align="center">
                  Kullanıcılar
                </Typography>
                <TextField
                  size="small"
                  placeholder="Kullanıcı ara..."
                  value={searchUser}
                  onChange={(e) => setSearchUser(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                  sx={{ width: "100%", maxWidth: "300px" }}
                />
              </Box>
              <CardContent
                sx={{
                  maxHeight: "500px", // Kart içeriğinin yüksekliğini sınırlayın
                  overflowY: "auto", // Dikey kaydırma çubuğu
                }}
              >
                <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                  {filteredUsers.map((user) => (
                    <Paper
                      key={user.UserID}
                      elevation={1}
                      sx={{
                        p: 2,
                        cursor: "pointer",
                        bgcolor:
                          selectedUser?.UserID === user.UserID
                            ? "primary.light"
                            : "background.paper",
                        "&:hover": {
                          bgcolor:
                            selectedUser?.UserID === user.UserID
                              ? "primary.light"
                              : "action.hover",
                        },
                      }}
                      onClick={() => setSelectedUser(user)}
                    >
                      <Typography variant="subtitle1">
                        {user.UserName}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {user.Email}
                      </Typography>
                    </Paper>
                  ))}
                </Box>
              </CardContent>
            </Card>
          </Grid>

          {/* 2. Card: Mağazalar Listesi */}
          <Grid item xs={12} md={4}>
            <Card elevation={3} sx={{ height: "100%", overflow: "hidden" }}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: 1,
                  p: 2, // Başlık ve arama çubuğu için iç boşluk
                }}
              >
                <Typography variant="h6" align="center">
                  Mağazalar
                </Typography>
                <TextField
                  size="small"
                  placeholder="Mağaza ara..."
                  value={searchShop}
                  onChange={(e) => setSearchShop(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                  sx={{ width: "100%", maxWidth: "300px" }}
                />
              </Box>
              <CardContent
                sx={{
                  maxHeight: "500px", // Kart içeriğinin yüksekliğini sınırlayın
                  overflowY: "auto", // Dikey kaydırma çubuğu
                }}
              >
                <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                  {filteredShops.map((shop) => (
                    <Paper
                      key={shop.ID}
                      elevation={1}
                      sx={{
                        p: 2,
                        cursor: "pointer",
                        bgcolor:
                          selectedUser &&
                          userShops[selectedUser.UserID]?.includes(shop.ID)
                            ? "success.light"
                            : "background.paper",
                        "&:hover": {
                          bgcolor:
                            selectedUser &&
                            userShops[selectedUser.UserID]?.includes(shop.ID)
                              ? "success.light"
                              : "action.hover",
                        },
                      }}
                      onClick={() => handleShopAssignment(shop.ID)}
                    >
                      <Typography variant="subtitle1">
                        {shop.ShopName}
                      </Typography>
                    </Paper>
                  ))}
                </Box>
              </CardContent>
            </Card>
          </Grid>

          {/* 3. Card: Seçili Kullanıcı Bilgisi (Sadece bir kullanıcı seçiliyse) */}
          {selectedUser && (
            <Grid item xs={12} md={4}>
              <Card elevation={3} sx={{ height: "100%" }}>
                <CardHeader title="Seçili Kullanıcı Mağazaları" />
                <CardContent>
                  <Typography variant="subtitle1" gutterBottom>
                    {selectedUser.UserName}
                  </Typography>
                  {/* Mağaza Chiplerini dikey göstermek için flexDirection: 'column' */}
                  <Box
                    sx={{ display: "flex", flexDirection: "column", gap: 1 }}
                  >
                    {userShops[selectedUser.UserID]?.map((shopId) => {
                      const shop = shopData.find((s) => s.ID === shopId);
                      return (
                        <Chip
                          key={shopId}
                          label={shop?.ShopName}
                          color="primary"
                          sx={{ borderRadius: 1 }}
                        />
                      );
                    })}
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          )}
        </Grid>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center", // Çok satırlı metinler için ortalama
            marginTop: 2, // Alt boşluk (opsiyonel)
          }}
        >
          <Button variant="contained" onClick={saveUserShops}>
            Yetki Kaydet
          </Button>
        </Box>
      </Box>
    );
  };

  const UserHierarchy = ({ userData }) => {
    const [searchManager, setSearchManager] = useState("");
    const [searchSubordinate, setSearchSubordinate] = useState("");
    const [selectedManager, setSelectedManager] = useState(null);
    const [userHierarchy, setUserHierarchy] = useState({});

    useEffect(() => {
      const fetchUserSubordinates = async () => {
        if (!selectedManager) return;

        try {
          const response = await axios.post(`${path}/api/getUserUsers`, {
            UserID: selectedManager.UserID,
          });

          const rows = response.data.data;
          if (Array.isArray(rows)) {
            // Çalışanların UserID'lerini alıyoruz
            const subordinateUserIds = rows.map((row) => row.StaffUserID);

            // userHierarchy state'ini güncelliyoruz
            setUserHierarchy((prev) => ({
              ...prev,
              [selectedManager.UserID]: subordinateUserIds,
            }));
          }
        } catch (error) {
          console.error("Error fetching user subordinates:", error);
        }
      };

      fetchUserSubordinates();
    }, [selectedManager, path]);

    const handleUserAssignment = (subordinateId) => {
      if (!selectedManager) return;

      setUserHierarchy((prev) => ({
        ...prev,
        [selectedManager.UserID]: prev[selectedManager.UserID]
          ? prev[selectedManager.UserID].includes(subordinateId)
            ? prev[selectedManager.UserID].filter((id) => id !== subordinateId)
            : [...prev[selectedManager.UserID], subordinateId]
          : [subordinateId],
      }));
    };

    const filteredManagers = userData.filter(
      (user) =>
        user.UserName.toLowerCase().includes(searchManager.toLowerCase()) ||
        user.Email.toLowerCase().includes(searchManager.toLowerCase())
    );

    const filteredSubordinates = userData.filter(
      (user) =>
        user.UserName.toLowerCase().includes(searchSubordinate.toLowerCase()) ||
        user.Email.toLowerCase().includes(searchSubordinate.toLowerCase())
    );

    const saveUserHierarchy = async () => {
      console.log(selectedManager);
      if (!selectedManager) return;

      const selectedSubordinateIds =
        userHierarchy[selectedManager.UserID] || [];

      const payload = selectedSubordinateIds.map((subordinateId) => {
        const subordinate = userData.find((u) => u.UserID === subordinateId);

        return {
          StaffUserName: subordinate?.UserName ?? "Unknown",
          StaffUserID: subordinate?.UserID ?? 0,
          CaptainUserID: selectedManager.UserID,
          CaptainUserName: selectedManager.UserName,
          Status: true,
        };
      });

      console.log(payload);

      try {

        await axios.post(`${path}/api/saveUserHierarchy`,{

          UserID: user?.ID,
          userShopAssignments: payload

        } );

        alert("Yönetici-çalışan ilişkileri başarıyla kaydedildi!");

      } catch (error) {
        console.error("Save error:", error);
        alert("Kayıt sırasında hata oluştu.");
      }
    };

    return (
      <Box
        sx={{
          p: 3,
          maxWidth: "90%",
          margin: "0 auto",
          maxHeight: "80vh",
          backgroundColor: "rgb(203, 214, 214)",
          overflow: "auto",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
            marginBottom: 2,
          }}
        >
          <Typography variant="h4" gutterBottom>
            Kullanıcı Yönetim Paneli
          </Typography>
        </Box>

        <Grid container spacing={3}>
          {/* Managers List */}
          <Grid item xs={12} md={4}>
            <Card elevation={3}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: 1,
                  p: 2,
                  overflow: "auto",
                  maxHeight: "80vh",
                }}
              >
                <Typography variant="h6" align="center">
                  Yöneticiler
                </Typography>
                <TextField
                  size="small"
                  placeholder="Yönetici ara..."
                  value={searchManager}
                  onChange={(e) => setSearchManager(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                  sx={{ width: "100%", maxWidth: "300px" }}
                />
              </Box>
              <CardContent
                sx={{
                  maxHeight: "500px",
                  overflowY: "auto",
                }}
              >
                <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                  {filteredManagers.map((user) => (
                    <Paper
                      key={user.UserID}
                      elevation={1}
                      sx={{
                        p: 2,
                        cursor: "pointer",
                        bgcolor:
                          selectedManager?.UserID === user.UserID
                            ? "primary.light"
                            : "background.paper",
                        "&:hover": {
                          bgcolor:
                            selectedManager?.UserID === user.UserID
                              ? "primary.light"
                              : "action.hover",
                        },
                      }}
                      onClick={() => setSelectedManager(user)}
                    >
                      <Typography variant="subtitle1">
                        {user.UserName}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {user.Email}
                      </Typography>
                    </Paper>
                  ))}
                </Box>
              </CardContent>
            </Card>
          </Grid>

          {/* Subordinates List */}
          <Grid item xs={12} md={4}>
            <Card elevation={3} sx={{ height: "100%", overflow: "hidden" }}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: 1,
                  p: 2,
                }}
              >
                <Typography variant="h6" align="center">
                  Çalışanlar
                </Typography>
                <TextField
                  size="small"
                  placeholder="Çalışan ara..."
                  value={searchSubordinate}
                  onChange={(e) => setSearchSubordinate(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                  sx={{ width: "100%", maxWidth: "300px" }}
                />
              </Box>
              <CardContent
                sx={{
                  maxHeight: "500px",
                  overflowY: "auto",
                }}
              >
                <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                  {filteredSubordinates.map((user) => (
                    <Paper
                      key={user.UserID}
                      elevation={1}
                      sx={{
                        p: 2,
                        cursor: "pointer",
                        bgcolor:
                          selectedManager &&
                          userHierarchy[selectedManager.UserID]?.includes(
                            user.UserID
                          )
                            ? "success.light"
                            : "background.paper",
                        "&:hover": {
                          bgcolor:
                            selectedManager &&
                            userHierarchy[selectedManager.UserID]?.includes(
                              user.UserID
                            )
                              ? "success.light"
                              : "action.hover",
                        },
                      }}
                      onClick={() => handleUserAssignment(user.UserID)}
                    >
                      <Typography variant="subtitle1">
                        {user.UserName}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {user.Email}
                      </Typography>
                    </Paper>
                  ))}
                </Box>
              </CardContent>
            </Card>
          </Grid>

          {/* Selected Manager's Subordinates */}
          {selectedManager && (
            <Grid item xs={12} md={4}>
              <Card elevation={3} sx={{ height: "100%" }}>
                <CardHeader title="Seçili Yöneticinin Çalışanları" />
                <CardContent>
                  <Typography variant="subtitle1" gutterBottom>
                    {selectedManager.UserName}
                  </Typography>
                  <Box
                    sx={{ display: "flex", flexDirection: "column", gap: 1 }}
                  >
                    {userHierarchy[selectedManager.UserID]?.map((userId) => {
                      const user = userData.find((u) => u.UserID === userId);
                      return (
                        <Chip
                          key={userId}
                          label={user?.UserName}
                          color="primary"
                          sx={{ borderRadius: 1 }}
                        />
                      );
                    })}
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          )}
        </Grid>

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
            marginTop: 2,
          }}
        >
          <Button variant="contained" onClick={saveUserHierarchy}>
            Yetkileri Kaydet
          </Button>
        </Box>
      </Box>
    );
  };

  const UserEffortManagement = () => {
    const [loading, setLoading] = useState(false);
    const effortTypes = ["Shop", "ARGE"];

    const [userEfforts, setUserEfforts] = useState(
      userData.map((user) => ({
        userId: user.UserID,
        userName: user.UserName,
        effortType1: "",
        effortType1Fee: "",
        effortType2: "",
        effortType2Fee: "",
      }))
    );

    useEffect(() => {
      const fetchShopData = async () => {
        setLoading(true);
        try {
          const response = await axios.post(
              path + "/api/AllEffortsFees",
              {
                UserID: user?.ID
              },
              {
                headers: {
                  "Content-Type": "application/json"
                }
              }
            );
          const parsedData = response.data;

          if (parsedData && parsedData.length > 0) {
            const updatedEfforts = userData.map((user) => {
              const existingEffort = parsedData.find(
                (effort) => effort.userId === user.UserID
              );

              return {
                userId: user.UserID,
                userName: user.UserName,
                effortType1: existingEffort?.effortType1 || "",
                effortType1Fee: existingEffort?.effortType1Fee || "",
                effortType2: existingEffort?.effortType2 || "",
                effortType2Fee: existingEffort?.effortType2Fee || "",
              };
            });

            setUserEfforts(updatedEfforts);
          }
        } catch (error) {
          console.error("Error fetching shop data:", error);
        } finally {
          setLoading(false);
        }
      };

      fetchShopData();
    }, []);

    const handleChange = (userId, field, value) => {
      setUserEfforts((prevEfforts) =>
        prevEfforts.map((effort) =>
          effort.userId === userId ? { ...effort, [field]: value } : effort
        )
      );
    };

    const handleSubmit = async () => {
      setLoading(true);
      try {
      const response = await axios.post(
          path + "/api/effortsFees",
          {
            efforts: userEfforts, 
            UserID: user?.ID
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );


        if (response.status === 200) {
          setAlertSeverity("success");
          setAlertMessage("Veriler başarılı bir şekilde kaydedildi.");
          setAlertOpen(true);
        } else {
          throw new Error("Kayıt sırasında bir hata oluştu");
        }
      } catch (error) {
        console.error("Hata:", error);
        setAlertSeverity("error");
        setAlertMessage(
          "Bir hata oluştu: " + (error.response?.data?.message || error.message)
        );
        setAlertOpen(true);
      } finally {
        setLoading(false);
      }
    };

    return (
      <>
        <Backdrop
          sx={{
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
            flexDirection: "column",
            gap: 2,
          }}
          open={loading}
        >
          <CircularProgress color="inherit" size={60} />
          <Typography variant="h6">
            İşlem yapılıyor, lütfen bekleyiniz...
          </Typography>
        </Backdrop>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            minHeight: "100vh",
            bgcolor: "rgb(180, 190, 190)",
            p: 2,
          }}
        >
          <Box
            sx={{
              overflowY: "auto",
              mx: "auto",
              width: "100%",
              p: 2,
              boxSizing: "border-box",
              "&::-webkit-scrollbar": {
                width: "8px",
              },
              "&::-webkit-scrollbar-track": {
                background: "#f1f1f1",
              },
              "&::-webkit-scrollbar-thumb": {
                background: "#888",
                borderRadius: "4px",
              },
              "&::-webkit-scrollbar-thumb:hover": {
                background: "#555",
              },
            }}
          >
            <TableContainer component={Paper} style={{ width: "50%" }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Kullanıcı</TableCell>
                    <TableCell>Effort Tipi 1</TableCell>
                    <TableCell style={{ width: "20%" }}>
                      Saatlik Ücret 1
                    </TableCell>
                    <TableCell>Effort Tipi 2</TableCell>
                    <TableCell style={{ width: "20%" }}>
                      Saatlik Ücret 2
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {userData.map((user) => {
                    const userEffort = userEfforts.find(
                      (e) => e.userId === user.UserID
                    ) || {
                      effortType1: "",
                      effortType1Fee: "",
                      effortType2: "",
                      effortType2Fee: "",
                    };

                    return (
                      <TableRow key={user.UserID}>
                        <TableCell>{user.UserName}</TableCell>
                        <TableCell>
                          <Select
                            fullWidth
                            value={userEffort.effortType1}
                            onChange={(e) =>
                              handleChange(
                                user.UserID,
                                "effortType1",
                                e.target.value
                              )
                            }
                          >
                            <MenuItem value="">
                              <em>Seçiniz</em>
                            </MenuItem>
                            {effortTypes.map((type) => (
                              <MenuItem key={type} value={type}>
                                {type}
                              </MenuItem>
                            ))}
                          </Select>
                        </TableCell>
                        <TableCell>
                          <TextField
                            type="number"
                            fullWidth
                            value={userEffort.effortType1Fee}
                            onChange={(e) =>
                              handleChange(
                                user.UserID,
                                "effortType1Fee",
                                e.target.value
                              )
                            }
                            InputProps={{
                              startAdornment: "$",
                            }}
                          />
                        </TableCell>
                        <TableCell>
                          <Select
                            fullWidth
                            value={userEffort.effortType2}
                            onChange={(e) =>
                              handleChange(
                                user.UserID,
                                "effortType2",
                                e.target.value
                              )
                            }
                          >
                            <MenuItem value="">
                              <em>Seçiniz</em>
                            </MenuItem>
                            {effortTypes.map((type) => (
                              <MenuItem key={type} value={type}>
                                {type}
                              </MenuItem>
                            ))}
                          </Select>
                        </TableCell>
                        <TableCell>
                          <TextField
                            type="number"
                            fullWidth
                            value={userEffort.effortType2Fee}
                            onChange={(e) =>
                              handleChange(
                                user.UserID,
                                "effortType2Fee",
                                e.target.value
                              )
                            }
                            InputProps={{
                              startAdornment: "$",
                            }}
                          />
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
            <div className="mt-4 flex justify-end">
              <Button
                variant="contained"
                color="primary"
                onClick={handleSubmit}
                disabled={loading}
              >
                {loading ? "Kaydediliyor..." : "Kaydet"}
              </Button>
            </div>
          </Box>
        </Box>
      </>
    );
  };

const ShopExpenses = () => {
    const [alertOpenShop, setAlertOpenShop] = useState(false);
    const [alertMessageShop, setAlertMessageShop] = useState("");
    const [alertSeverityShop, setAlertSeverityShop] = useState("success");
    const [expenses, setExpenses] = useState([]);
    const [selectedExpense, setSelectedExpense] = useState({
      id: null,
      shop: "",
      expenseType: "",
      startDate: null,
      endDate: null,
      amount: "",
    });
    const [importModalOpen, setImportModalOpen] = useState(false);
    const [importedData, setImportedData] = useState([]);
    const [importSuccess, setImportSuccess] = useState(false);
    
    const [selectedIds, setSelectedIds] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    
    const [currentMonth, setCurrentMonth] = useState(dayjs().format('YYYY-MM'));
    const [monthlyExpenses, setMonthlyExpenses] = useState([]);
    const [availableMonths, setAvailableMonths] = useState([]);
    const [monthlyTotal, setMonthlyTotal] = useState(0);
    
    dayjs.extend(utc);
    dayjs.extend(timezone);
    
    dayjs.locale('tr');
  
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
  
    const shops = shopdata.map((shop) => shop.ShopName);
    const expenseTypes = ["Shop", "Personel"];
  
    useEffect(() => {
      fetchExpenses();
    }, []);

    useEffect(() => {
      if (expenses.length > 0) {
        processMonthlyData();
      }
    }, [expenses, currentMonth]);
  
    const fetchExpenses = async () => {
      try {
        const response = await axios.post(
          path + '/api/getExpenses',
          {
            UserID: user?.ID
          },
          {
            headers: {
              "Content-Type": "application/json"
            }
          }
        );

    
        const formattedExpenses = response.data.map((expense) => ({
          ...expense,
          startDate: expense.startDate ? dayjs.utc(expense.startDate).tz("Europe/Istanbul") : null,
          endDate: expense.endDate ? dayjs.utc(expense.endDate).tz("Europe/Istanbul") : null,
        }));
    
        setExpenses(formattedExpenses);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching expenses:', error);
        setError('Failed to fetch expenses');
        setLoading(false);
      }
    };

    // Aylık verileri işle
    const processMonthlyData = () => {
      // Mevcut ayları bul
      const months = new Set();
      expenses.forEach(expense => {
        if (expense.startDate) {
          months.add(expense.startDate.format('YYYY-MM'));
        }
        if (expense.endDate) {
          months.add(expense.endDate.format('YYYY-MM'));
        }
      });

      const sortedMonths = Array.from(months).sort((a, b) => b.localeCompare(a));
      setAvailableMonths(sortedMonths);

      if (!sortedMonths.includes(currentMonth) && sortedMonths.length > 0) {
        setCurrentMonth(sortedMonths[0]);
        return; // useEffect tekrar çalışacak
      }

      const filteredExpenses = expenses.filter(expense => {
        const expenseMonth = expense.startDate ? expense.startDate.format('YYYY-MM') : 
                           expense.endDate ? expense.endDate.format('YYYY-MM') : null;
        return expenseMonth === currentMonth;
      });

      setMonthlyExpenses(filteredExpenses);
      
      const total = filteredExpenses.reduce((sum, expense) => sum + parseFloat(expense.amount || 0), 0);
      setMonthlyTotal(total);

      setSelectedIds([]);
      setSelectAll(false);
    };

    // Ay değiştirme
    const handleMonthChange = (e) => {
      setCurrentMonth(e.target.value);
    };

    // Önceki/Sonraki ay
    const goToPreviousMonth = () => {
      const newMonth = dayjs(currentMonth).subtract(1, 'month').format('YYYY-MM');
      setCurrentMonth(newMonth);
    };

    const goToNextMonth = () => {
      const newMonth = dayjs(currentMonth).add(1, 'month').format('YYYY-MM');
      setCurrentMonth(newMonth);
    };
  
    const handleInputChange = (field, value) => {
      setSelectedExpense((prev) => ({
        ...prev,
        [field]: value ? dayjs(value).tz("Europe/Istanbul").startOf('day') : null,
      }));
    };
    
    const handleShopChange = (e) => {
      setSelectedExpense(prev => ({
        ...prev,
        shop: e.target.value
      }));
    };
  
    const handleExpenseTypeChange = (e) => {
      setSelectedExpense(prev => ({
        ...prev,
        expenseType: e.target.value
      }));
    };
  
    const handleAmountChange = (e) => {
      setSelectedExpense(prev => ({
        ...prev,
        amount: e.target.value
      }));
    };
  
 const handleAddOrUpdateExpense = async () => {
  try {
    console.log('Selected Expense:', user?.ID);
    const formattedExpense = {
      UserID: user?.ID, 
      shop: selectedExpense.shop,
      expenseType: selectedExpense.expenseType,
      startDate: selectedExpense.startDate ? dayjs(selectedExpense.startDate).tz("Europe/Istanbul").format('YYYY-MM-DD') : null,
      endDate: selectedExpense.endDate ? dayjs(selectedExpense.endDate).tz("Europe/Istanbul").format('YYYY-MM-DD') : null,
      amount: selectedExpense.amount
    };

    if (selectedExpense.id) {
      await axios.put(`${path}/api/expenses/${selectedExpense.id}`, formattedExpense);
    } else {
      await axios.post(path + '/api/expenses', formattedExpense);
    }

    setAlertSeverityShop("success");
    setAlertMessageShop("İşlem başarılı!");
    setAlertOpenShop(true);
    fetchExpenses();
    setSelectedExpense({
      id: null,
      shop: "",
      expenseType: "",
      startDate: null,
      endDate: null,
      amount: "",
    });
  } catch (error) {
    console.error('Error saving expense:', error);
    setAlertSeverityShop("error");
    setAlertMessageShop("İşlem sırasında bir hata oluştu!");
    setAlertOpenShop(true);
  }
};
  
    const handleDeleteExpense = async (id) => {
      try {
       await axios.delete(`${path}/api/expenses/${id}`, {
          data: {
            UserID: user?.ID
          },
          headers: {
            "Content-Type": "application/json"
          }
        });
       
        setAlertSeverityShop("success");
        setAlertMessageShop("Gider silindi!");
        setAlertOpenShop(true);
        fetchExpenses();
      } catch (error) {
        console.error('Error deleting expense:', error);
       
        setAlertSeverityShop("error");
        setAlertMessageShop("Gider silinirken bir hata oluştu!" + error);
        setAlertOpenShop(true);
      }
    };

    // Toplu silme fonksiyonu
    const handleBulkDelete = async () => {
      if (selectedIds.length === 0) {
        setAlertSeverityShop("warning");
        setAlertMessageShop("Lütfen silinecek kayıtları seçin!");
        setAlertOpenShop(true);
        return;
      }

      if (window.confirm(`${selectedIds.length} kayıt silinecek. Emin misiniz?`)) {
        try {
          await axios.delete(`${path}/api/expenses`, {
            data: {
                ids: selectedIds,
                UserID: user?.ID
              }

          });
          
          setAlertSeverityShop("success");
          setAlertMessageShop(`${selectedIds.length} gider silindi!`);
          setAlertOpenShop(true);
          
          fetchExpenses();
        } catch (error) {
          console.error('Error deleting expenses:', error);
          setAlertSeverityShop("error");
          setAlertMessageShop("Giderler silinirken bir hata oluştu!");
          setAlertOpenShop(true);
        }
      }
    };

    // Checkbox işlemleri (aylık veriler için)
    const handleSelectAll = (e) => {
      const checked = e.target.checked;
      setSelectAll(checked);
      
      if (checked) {
        setSelectedIds(monthlyExpenses.map(expense => expense.id));
      } else {
        setSelectedIds([]);
      }
    };

    const handleSelectRow = (id) => {
      setSelectedIds(prev => {
        if (prev.includes(id)) {
          return prev.filter(selectedId => selectedId !== id);
        } else {
          return [...prev, id];
        }
      });
    };

    // Tüm aylık kayıtlar seçili mi kontrol et
    useEffect(() => {
      if (monthlyExpenses.length > 0) {
        setSelectAll(selectedIds.length === monthlyExpenses.length);
      }
    }, [selectedIds, monthlyExpenses]);
  
    const handleRowClick = (expense) => {
      setSelectedExpense({
        ...expense,
        startDate: expense.startDate ? dayjs(expense.startDate).local() : null,
        endDate: expense.endDate ? dayjs(expense.endDate).local() : null,
      });
    };
  
    // Excel Template Creation
    const generateExcelTemplate = () => {
      const workbook = XLSX.utils.book_new();
      
      const headers = ["Shop", "Expense Type", "Start Date (YYYY-MM-DD)", "End Date (YYYY-MM-DD)", "Amount"];
      const data = [
        headers,
        ["", "", "", "", ""]
      ];
      
      const ws = XLSX.utils.aoa_to_sheet(data);
      
      ['C2', 'D2'].forEach(cell => {
        if (!ws[cell]) ws[cell] = {};
        ws[cell].t = 's';
        ws[cell].z = '@';
      });
    
      ws['!cols'] = [
        { wch: 20 },
        { wch: 15 },
        { wch: 20 },
        { wch: 20 },
        { wch: 10 }
      ];
    
      XLSX.utils.book_append_sheet(workbook, ws, "Expenses Template");
      XLSX.writeFile(workbook, "expenses_template.xlsx");
    };
    
    const templateInstructions = `
      1. İndirilen Excel şablonunu açın
      2. Aşağıdaki bilgileri girin:
         - Shop: ${shops.join(', ')} değerlerinden birini seçin
         - Expense Type: Shop veya Personel değerlerinden birini seçin
         - Start Date: YYYY-MM-DD formatında başlangıç tarihi
         - End Date: YYYY-MM-DD formatında bitiş tarihi
         - Amount: Sayısal değer (örn: 1500)
      3. Dosyayı kaydedin ve sisteme yükleyin
    `;
  
    const handleFileUpload = (e) => {
      const file = e.target.files[0];
      if (!file) return;
  
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: 'array' });
          const sheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[sheetName];
          const jsonData = XLSX.utils.sheet_to_json(worksheet);
          
          const validatedData = jsonData.map(row => {
            if (!shops.includes(row.Shop)) {
              throw new Error(`Invalid Shop value: ${row.Shop}. Must be one of: ${shops.join(', ')}`);
            }
            
            if (!expenseTypes.includes(row["Expense Type"])) {
              throw new Error(`Invalid Expense Type value: ${row["Expense Type"]}. Must be one of: ${expenseTypes.join(', ')}`);
            }
            
            let startDate = null;
            let endDate = null;
            
            try {
              startDate = row["Start Date (YYYY-MM-DD)"] ? 
                dayjs(row["Start Date (YYYY-MM-DD)"]).tz("Europe/Istanbul").format('YYYY-MM-DD') : null;
            } catch (error) {
              throw new Error(`Invalid Start Date format. Please use YYYY-MM-DD format.`);
            }
            
            try {
              endDate = row["End Date (YYYY-MM-DD)"] ? 
                dayjs(row["End Date (YYYY-MM-DD)"]).tz("Europe/Istanbul").format('YYYY-MM-DD') : null;
            } catch (error) {
              throw new Error(`Invalid End Date format. Please use YYYY-MM-DD format.`);
            }
            
            if (isNaN(parseFloat(row.Amount))) {
              throw new Error(`Invalid Amount value: ${row.Amount}. Must be a number.`);
            }
            
            
            return {
              UserID: user?.ID,
              shop: row.Shop,
              expenseType: row["Expense Type"],
              startDate,
              endDate,
              amount: parseFloat(row.Amount)
            };
          });
          
          setImportedData(validatedData);
          setImportSuccess(true);
        } catch (error) {
          console.error('Error reading Excel file:', error);
          setAlertSeverityShop("error");
          setAlertMessageShop(`Excel dosyası okunurken hata oluştu: ${error.message}`);
          setAlertOpenShop(true);
          setImportSuccess(false);
        }
      };
      reader.readAsArrayBuffer(file);
    };
  
    const saveImportedData = async () => {
      try {
        const promises = importedData.map(expense => {
          return axios.post(path + '/api/expenses',
             expense);
        });
        
        await Promise.all(promises);
        
        setAlertSeverityShop("success");
        setAlertMessageShop(`${importedData.length} kayıt başarıyla içe aktarıldı!`);
        setAlertOpenShop(true);
        fetchExpenses();
        setImportModalOpen(false);
        setImportedData([]);
        setImportSuccess(false);
      } catch (error) {
        console.error('Error saving imported data:', error);
        setAlertSeverityShop("error");
        setAlertMessageShop("Veriler kaydedilirken bir hata oluştu!");
        setAlertOpenShop(true);
      }
    };
    
    if (loading) return <div>Loading...</div>;
    if (error) return <div>Error: {error}</div>;
  
    return (
      <>
      <Snackbar
        open={alertOpenShop}
        autoHideDuration={6000}
        onClose={() => setAlertOpenShop(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={() => setAlertOpenShop(false)} severity={alertSeverityShop}>
          {alertMessageShop}
        </Alert>
      </Snackbar>
      
      {/* Excel Import Modal */}
      <Dialog 
        open={importModalOpen} 
        onClose={() => setImportModalOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Excel İçe Aktarma</DialogTitle>
        <DialogContent>
          <Box sx={{ mt: 2, mb: 4 }}>
            <Typography variant="subtitle1" fontWeight="bold">Excel Şablonu</Typography>
            <Typography variant="body2" sx={{ whiteSpace: 'pre-line', mb: 2 }}>
              {templateInstructions}
            </Typography>
            
            <Button 
              variant="outlined" 
              color="primary" 
              onClick={generateExcelTemplate}
              startIcon={<DownloadIcon />}
              sx={{ mt: 1, mb: 3 }}
            >
              Excel Şablonu İndir
            </Button>
            
            <Divider sx={{ my: 2 }} />
            
            <Typography variant="subtitle1" fontWeight="bold" sx={{ mt: 2 }}>
              Excel Dosyası Yükle
            </Typography>
            
            <Button
              variant="contained"
              component="label"
              sx={{ mt: 2 }}
            >
              Dosya Seç
              <input
                type="file"
                accept=".xlsx, .xls"
                hidden
                onChange={handleFileUpload}
              />
            </Button>
            
            {importSuccess && (
              <>
                <Typography variant="subtitle1" sx={{ mt: 3, mb: 1 }}>
                  Yüklenen Veriler ({importedData.length} kayıt)
                </Typography>
                
                <TableContainer component={Paper} sx={{ maxHeight: 300 }}>
                  <Table stickyHeader size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell>Shop</TableCell>
                        <TableCell>Expense Type</TableCell>
                        <TableCell>Start Date</TableCell>
                        <TableCell>End Date</TableCell>
                        <TableCell>Amount</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {importedData.map((row, index) => (
                        <TableRow key={index}>
                          <TableCell>{row.shop}</TableCell>
                          <TableCell>{row.expenseType}</TableCell>
                          <TableCell>{row.startDate}</TableCell>
                          <TableCell>{row.endDate}</TableCell>
                          <TableCell>${row.amount}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
                
                <Button
                  variant="contained"
                  color="primary"
                  sx={{ mt: 2 }}
                  onClick={saveImportedData}
                >
                  Verileri Kaydet
                </Button>
              </>
            )}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setImportModalOpen(false)} color="primary">
            Kapat
          </Button>
        </DialogActions>
      </Dialog>
      
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 4,
            mt: 4,
            p: 2,
            minHeight: "100vh",
          }}
        >
          {/* Input Alanları */}
          <Paper elevation={3} sx={{ p: 4, bgcolor: 'white', width: '80%', borderRadius: 2 }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, alignItems: 'center' }}>
              <Typography variant="h5" sx={{ textAlign: 'center', fontWeight: 'bold', mb: 2 }}>
                Shop Diğer Ücretler Tanımlama Ekranı
              </Typography>
  
              {/* Shop and Expense Type Selects */}
              <Box sx={{ display: 'flex', gap: 3, width: '100%', justifyContent: 'center' }}>
                <Select
                  label="Shop"
                  value={selectedExpense.shop}
                  onChange={handleShopChange}
                  fullWidth
                  sx={{ maxWidth: 260 }}
                >
                  <MenuItem value="">
                    <em>Select Shop</em>
                  </MenuItem>
                  {shops.map((shop) => (
                    <MenuItem key={shop} value={shop}>
                      {shop}
                    </MenuItem>
                  ))}
                </Select>
                <Select
                  label="Expense Type"
                  value={selectedExpense.expenseType}
                  onChange={handleExpenseTypeChange}
                  fullWidth
                  sx={{ maxWidth: 260 }}
                >
                  <MenuItem value="">
                    <em>Select Expense Type</em>
                  </MenuItem>
                  {expenseTypes.map((type) => (
                    <MenuItem key={type} value={type}>
                      {type}
                    </MenuItem>
                  ))}
                </Select>
              </Box>
  
              {/* Date Pickers */}
              <Box sx={{ display: 'flex', gap: 3, width: '100%', justifyContent: 'center' }}>
                <DatePicker
                  label="Start Date"
                  value={selectedExpense.startDate}
                  onChange={(newValue) => handleInputChange('startDate', newValue)}
                  renderInput={(params) => <TextField {...params} fullWidth sx={{ maxWidth: 250 }} />}
                />
                <DatePicker
                  label="End Date"
                  value={selectedExpense.endDate}
                  onChange={(newValue) => handleInputChange('endDate', newValue)}
                  renderInput={(params) => <TextField {...params} fullWidth sx={{ maxWidth: 250 }} />}
                />
              </Box>
  
              {/* Amount Input */}
              <TextField
                label="Amount"
                type="number"
                value={selectedExpense.amount}
                onChange={handleAmountChange} 
                fullWidth
                sx={{ maxWidth: 300 }}
                InputProps={{
                  startAdornment: <Box component="span" sx={{ mr: 1 }}>$</Box>,
                }}
              />
  
              {/* Buttons */}
              <Box sx={{ display: 'flex', gap: 2, mt: 2, justifyContent: 'center', width: '100%' }}>
                <Button variant="contained" color="primary" onClick={handleAddOrUpdateExpense} sx={{ px: 4 }}>
                  {selectedExpense.id ? 'Update' : 'Add'}
                </Button>
                {selectedExpense.id && (
                  <Button variant="contained" color="secondary" onClick={() => handleDeleteExpense(selectedExpense.id)} sx={{ px: 4 }}>
                    Delete
                  </Button>
                )}
                <Button 
                  variant="contained" 
                  color="info" 
                  startIcon={<UploadFileIcon />}
                  onClick={() => setImportModalOpen(true)}
                  sx={{ px: 4 }}
                >
                  Excel İçe Aktar
                </Button>
              </Box>
            </Box>
          </Paper>

          {/* Aylık Navigasyon */}
          <Paper elevation={3} sx={{ p: 3, bgcolor: 'white', width: '80%', borderRadius: 2 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
              <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                Aylık Giderler Görünümü
              </Typography>
              <Typography variant="h6" sx={{ color: 'primary.main', fontWeight: 'bold' }}>
                Toplam: ${monthlyTotal.toFixed(2)}
              </Typography>
            </Box>
            
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, justifyContent: 'center', mb: 2 }}>
              <IconButton onClick={goToPreviousMonth} color="primary">
                <ArrowBackIcon />
              </IconButton>
              
              <Select
                value={currentMonth}
                onChange={handleMonthChange}
                sx={{ minWidth: 200 }}
              >
                {availableMonths.map((month) => (
                  <MenuItem key={month} value={month}>
                    {dayjs(month).format('MMMM YYYY')}
                  </MenuItem>
                ))}
              </Select>
              
              <IconButton onClick={goToNextMonth} color="primary">
                <ArrowForwardIcon />
              </IconButton>
            </Box>

            <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1 }}>
              <Chip 
                label={`${monthlyExpenses.length} Kayıt`} 
                color="info" 
                variant="outlined" 
              />
              <Chip 
                label={`${selectedIds.length} Seçili`} 
                color="warning" 
                variant="outlined" 
              />
            </Box>
          </Paper>
  
          {/* Toplu Silme Butonları */}
          <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', width: '80%' }}>
            <Button
              variant="contained"
              color="error"
              onClick={handleBulkDelete}
              disabled={selectedIds.length === 0}
              startIcon={<DeleteIcon />}
              sx={{ px: 4 }}
            >
              Seçilenleri Sil ({selectedIds.length})
            </Button>
            <Button
              variant="outlined"
              onClick={() => {
                setSelectedIds([]);
                setSelectAll(false);
              }}
              disabled={selectedIds.length === 0}
              sx={{ px: 4 }}
            >
              Seçimi Temizle
            </Button>
          </Box>

          {/* Aylık Tablo */}
          <TableContainer component={Paper} sx={{ width: "80%" }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell padding="checkbox">
                    <Checkbox
                      checked={selectAll}
                      onChange={handleSelectAll}
                      indeterminate={selectedIds.length > 0 && selectedIds.length < monthlyExpenses.length}
                    />
                  </TableCell>
                  <TableCell>Shop</TableCell>
                  <TableCell>Expense Type</TableCell>
                  <TableCell>Start Date</TableCell>
                  <TableCell>End Date</TableCell>
                  <TableCell>Amount ($)</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {monthlyExpenses.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={6} sx={{ textAlign: 'center', py: 4 }}>
                      <Typography variant="body1" color="text.secondary">
                        {dayjs(currentMonth).format('MMMM YYYY')} ayında kayıt bulunamadı
                      </Typography>
                    </TableCell>
                  </TableRow>
                ) : (
                  monthlyExpenses.map((expense) => (
                    <TableRow key={expense.id}>
                      <TableCell padding="checkbox">
                        <Checkbox
                          checked={selectedIds.includes(expense.id)}
                          onChange={() => handleSelectRow(expense.id)}
                        />
                      </TableCell>
                      <TableCell onClick={() => handleRowClick(expense)} sx={{ cursor: 'pointer' }}>
                        {expense.shop}
                      </TableCell>
                      <TableCell onClick={() => handleRowClick(expense)} sx={{ cursor: 'pointer' }}>
                        {expense.expenseType}
                      </TableCell>
                      <TableCell onClick={() => handleRowClick(expense)} sx={{ cursor: 'pointer' }}>
                        {expense.startDate ? expense.startDate.format('YYYY-MM-DD') : ''}
                      </TableCell>
                      <TableCell onClick={() => handleRowClick(expense)} sx={{ cursor: 'pointer' }}>
                        {expense.endDate ? expense.endDate.format('YYYY-MM-DD') : ''}
                      </TableCell>
                      <TableCell onClick={() => handleRowClick(expense)} sx={{ cursor: 'pointer' }}>
                        ${expense.amount}
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </LocalizationProvider>
      </>
    );
};

  const ScreenShotAuth = () => {
    const [screenShotAuthData, setScreenShotAuthData] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState({});
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState('success');
    const [previousAuths, setPreviousAuths] = useState([]);
    const [userData, setUserData] = useState([]);
    useEffect(() => {
      const fetchData = async () => {
        try {
          const [screenshotResponse, userDataResponse, previousAuthResponse] = await Promise.all([
            axios.get(`${path}/api/GetSecreenShotsUsers`),
            axios.post(`${path}/api/GetUserData`,{UserID: user?.ID}),
            axios.get(`${path}/api/GetPreviousScreenShotAuth`)
          ]);
  
          const screenshotData = screenshotResponse.data;
          const userData = userDataResponse.data;
          const previousAuthData = previousAuthResponse.data;
  
          // Önceki eşleşmeleri dikkate alarak initial state'i oluştur
          const initialSelectedUsers = screenshotData.reduce((acc, item) => {
            // Eğer daha önce eşleşmiş ise o eşleşmeyi kullan
            const matchedAuth = previousAuthData.find(
              auth => auth.LocalIP === item.LocalIP && auth.HostName === item.HostName
            );
            
            // Eğer eşleşen bir kullanıcı varsa, UserID'yi seç
            acc[item.LocalIP] = matchedAuth 
              ? matchedAuth.SystemUserID 
              : (
                // Kullanıcı adı benzerliğine göre otomatik eşleştirme
                userData.find(user => 
                  user.UserName.toLowerCase() === item.UserName.toLowerCase()
                )?.UserID || ''
              );
            
            return acc;
          }, {});
  
          setScreenShotAuthData(screenshotData);
          setUserData(userData);
          setPreviousAuths(previousAuthData);
          setSelectedUsers(initialSelectedUsers);
  
        } catch (error) {
          console.error("Error fetching data:", error);
          handleSnackbar('Veri yükleme hatası', 'error');
        }
      };
  
      fetchData();
    }, []);
  
  
    const handleUserChange = (localIp, userId) => {
      setSelectedUsers(prev => ({
        ...prev,
        [localIp]: userId
      }));
    };
  
    const handleSnackbar = (message, severity = 'success') => {
      setSnackbarMessage(message);
      setSnackbarSeverity(severity);
      setOpenSnackbar(true);
    };
  
    const handleCloseSnackbar = () => {
      setOpenSnackbar(false);
    };
  
    const handleSave = async () => {
      try {
        // Sadece seçim yapılmış ve daha önce eşleşmemiş kayıtları filtrele
        const authData = screenShotAuthData.filter(item => 
          selectedUsers[item.LocalIP] && 
          !previousAuths.some(
            auth => 
              auth.LocalIP === item.LocalIP && 
              auth.HostName === item.HostName && 
              auth.SystemUserID === selectedUsers[item.LocalIP]
          )
        ).map(item => {
          const selectedUserId = selectedUsers[item.LocalIP];
          const selectedUser = userData.find(user => user.UserID === selectedUserId);
          
          return {
            LocalIP: item.LocalIP,
            HostName: item.HostName,
            UserName: item.UserName,
            SystemUserID: selectedUserId,
            SystemUserName: selectedUser ? selectedUser.UserName : null
          };
        });
  
        // Eğer yeni kayıt yoksa işlem yapma
        if (authData.length === 0) {
          handleSnackbar('Kaydetilecek yeni bir eşleşme yok', 'info');
          return;
        }
  
        const response = await axios.post(`${path}/api/SaveScreenShotAuth`, authData);
        
        handleSnackbar('Kayıt başarıyla gerçekleştirildi');
        
        // Yeni eklenen kayıtları previousAuths'a ekle
        setPreviousAuths([...previousAuths, ...authData]);
  
      } catch (error) {
        console.error("Kaydetme hatası:", error);
        handleSnackbar('Kaydetme sırasında bir hata oluştu', 'error');
      }
    };
    return (
      <>
       <Snackbar 
          open={openSnackbar} 
          autoHideDuration={6000} 
          onClose={handleCloseSnackbar}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert 
            onClose={handleCloseSnackbar} 
            severity={snackbarSeverity} 
            sx={{ width: '100%' }}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>

   <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Local IP</TableCell>
              <TableCell>Hostname</TableCell>
              <TableCell>Current Username</TableCell>
              <TableCell>Assign User</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {screenShotAuthData.map((item) => (
              <TableRow key={item.LocalIP}>
                <TableCell>{item.LocalIP}</TableCell>
                <TableCell>{item.HostName}</TableCell>
                <TableCell>{item.UserName}</TableCell>
                <TableCell>
                  <FormControl fullWidth>
                    <InputLabel>Select User</InputLabel>
                    <Select
                      value={selectedUsers[item.LocalIP] || ''}
                      label="Select User"
                      onChange={(e) => handleUserChange(item.LocalIP, e.target.value)}
                    >
                      {userData.map((user) => (
                        <MenuItem key={user.UserID} value={user.UserID}>
                          {user.UserName}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
        
        <Button 
          variant="contained" 
          color="primary" 
          onClick={handleSave}
          style={{ marginTop: 16 }}
        >
          Kaydet
        </Button>
  
        
      </>
    );
  };

  const ShopManagementPanel = () => {
    
    const [shops, setShops] = useState([
    ]);
    useEffect(() => { 
      const fetchShopData = async () => {
        try {
          const response = await axios.post(
            path + "/api/GetAllShopData",
            {
              UserID: user?.ID
            },
            {
              headers: {
                "Content-Type": "application/json"
              }
            }
          );

          const parsedData = response.data.map(shop => ({
            id: shop.ID, 
            shopName: shop.ShopName, 
            status: shop.Status === 1 ? "active" : "inactive"
          }));
    
          setShops(parsedData);
        } catch (error) {
          console.error("Error fetching shop data:", error);
        }
      };
    
      fetchShopData();
    }, []);
    
    const [openAddDialog, setOpenAddDialog] = useState(false);
    const [openEditDialog, setOpenEditDialog] = useState(false);
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [currentShop, setCurrentShop] = useState({ id: null, shopName: "", status: "" });
    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
    
    const handleAddDialogOpen = () => {
      setCurrentShop({ id: generateId(), shopName: "", status: "active" });
      setOpenAddDialog(true);
    };
    
    const handleEditDialogOpen = (shop) => {
      setCurrentShop({ ...shop });
      setOpenEditDialog(true);
    };
    
    const handleDeleteDialogOpen = (shop) => {
      setCurrentShop({ ...shop });
      setOpenDeleteDialog(true);
    };
    
    const handleAddDialogClose = () => {
      setOpenAddDialog(false);
    };
    
    const handleEditDialogClose = () => {
      setOpenEditDialog(false);
    };
    
    const handleDeleteDialogClose = () => {
      setOpenDeleteDialog(false);
    };
    
    // Snackbar kapatma fonksiyonu
    const handleSnackbarClose = () => {
      setSnackbar({ ...snackbar, open: false });
    };
    
    // Form değişikliklerini yönetme
    const handleInputChange = (e) => {
      const { name, value } = e.target;
      setCurrentShop({ ...currentShop, [name]: value });
    };
    
    const generateId = () => {
      return Math.max(...shops.map(shop => shop.id), 0) + 1;
    };
    
    // Yeni mağaza ekleme
    const handleAddShop = async () => {
      // Mağaza adı boş mu kontrolü
      if (currentShop.shopName.trim() === '') {
        setSnackbar({ open: true, message: 'Mağaza adı boş olamaz!', severity: 'error' });
        return;
      }
    
      try {
        // API'ye POST isteği gönder
        const response = await axios.post(path + '/api/InsertNewShop', {
          ShopName: currentShop.shopName,
          Status: currentShop.status,
          UserID: user?.ID
        });
    
        // Başarılı yanıt durumunda
        if (response.status === 200) {
          setShops([...shops, currentShop]); // Mağazayı yerel listeye ekle
          setOpenAddDialog(false); // Dialog'u kapat
          setSnackbar({ open: true, message: 'Mağaza başarıyla eklendi!', severity: 'success' });
        }
      } catch (error) {
        console.error('API Hatası:', error);
        setSnackbar({ open: true, message: 'Mağaza eklenirken bir hata oluştu.', severity: 'error' });
      }
    };
    
    // Mağaza güncelleme
    const handleUpdateShop = async () => {
      if (currentShop.shopName.trim() === '') {
        setSnackbar({ open: true, message: 'Mağaza adı boş olamaz!', severity: 'error' });
        return;
      }
    
      try {
        const response = await axios.post(path + '/api/UpdateShop', {
          ShopName: currentShop.shopName,
          OldShopName: shops.find(shop => shop.id === currentShop.id)?.shopName || "",
          ShopID: currentShop.id,
          Status: currentShop.status,
          UserID: user?.ID
        });
    
        if (response.status === 200) {
          const updatedShops = shops.map(shop => 
            shop.id === currentShop.id ? { ...shop, shopName: currentShop.shopName, status: currentShop.status } : shop
          );
    
          setShops(updatedShops);
          setOpenEditDialog(false);
          setSnackbar({ open: true, message: 'Mağaza başarıyla güncellendi!', severity: 'success' });
        }
      } catch (error) {
        console.error('API Hatası:', error);
        setSnackbar({ open: true, message: 'Mağaza güncellenirken bir hata oluştu.', severity: 'error' });
      }
    };
    
    const handleDeleteShop = async () => {
      try {
        const response = await axios.post(path + "/api/DeleteShop", {
          ShopID: currentShop.id,
          UserID: user?.ID
        });
    
        if (response.status === 200) {
          const updatedShops = shops.filter(shop => shop.id !== currentShop.id);
          setShops(updatedShops);
          setOpenDeleteDialog(false);
          setSnackbar({ open: true, message: 'Mağaza başarıyla silindi!', severity: 'success' });
        }
      } catch (error) {
        console.error("API Hatası:", error);
        setSnackbar({ open: true, message: 'Mağaza silinirken bir hata oluştu.', severity: 'error' });
      }
    };
    
    const getStatusStyle = (status) => {
      switch(status) {
        case 'active':
          return { color: '#388e3c', backgroundColor: '#e8f5e9', padding: '4px 8px', borderRadius: '4px' };
        case 'maintenance':
          return { color: '#f57c00', backgroundColor: '#fff3e0', padding: '4px 8px', borderRadius: '4px' };
        case 'inactive':
          return { color: '#d32f2f', backgroundColor: '#ffebee', padding: '4px 8px', borderRadius: '4px' };
        default:
          return { color: '#757575', backgroundColor: '#f5f5f5', padding: '4px 8px', borderRadius: '4px' };
      }
    };
    
    // Durum adını Türkçe gösterme
    const getStatusLabel = (status) => {
      switch(status) {
        case 'active':
          return 'Aktif';
        case 'inactive':
          return 'Pasif';
        default:
          return status;
      }
    };
    
    return (
      <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
          <Typography variant="h4" component="h1" gutterBottom>
            Mağaza Yönetim Paneli
          </Typography>
          <Button 
            variant="contained" 
            color="primary" 
            startIcon={<AddIcon />}
            onClick={handleAddDialogOpen}
          >
            Yeni Mağaza Ekle
          </Button>
        </Box>
        
        <Paper sx={{ width: '100%', overflow: 'hidden' }}>
          <TableContainer sx={{ maxHeight: 440 }}>
            <Table stickyHeader aria-label="mağaza listesi">
              <TableHead>
                <TableRow>
                  <TableCell>ID</TableCell>
                  <TableCell>Mağaza Adı</TableCell>
                  <TableCell>Durum</TableCell>
                  <TableCell align="right">İşlemler</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {shops.map((shop) => (
                  <TableRow hover key={shop.id}>
                    <TableCell>{shop.id}</TableCell>
                    <TableCell>{shop.shopName}</TableCell>
                    <TableCell>
                      <span style={getStatusStyle(shop.status)}>
                        {getStatusLabel(shop.status)}
                      </span>
                    </TableCell>
                    <TableCell align="right">
                      <IconButton 
                        color="primary" 
                        size="small"
                        onClick={() => handleEditDialogOpen(shop)}
                      >
                        <EditIcon />
                      </IconButton>
                      <IconButton 
                        color="error" 
                        size="small"
                        onClick={() => handleDeleteDialogOpen(shop)}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
        
        {/* Yeni Mağaza Ekleme Dialog'u */}
        <Dialog open={openAddDialog} onClose={handleAddDialogClose}>
          <DialogTitle>Yeni Mağaza Ekle</DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              margin="dense"
              name="shopName"
              label="Mağaza Adı"
              type="text"
              fullWidth
              variant="outlined"
              value={currentShop.shopName}
              onChange={handleInputChange}
            />
            <FormControl fullWidth margin="dense">
              <InputLabel id="status-select-label">Durum</InputLabel>
              <Select
                labelId="status-select-label"
                id="status-select"
                name="status"
                value={currentShop.status}
                label="Durum"
                onChange={handleInputChange}
              >
                <MenuItem value="active">Aktif</MenuItem>
                <MenuItem value="inactive">Pasif</MenuItem>
              </Select>
            </FormControl>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleAddDialogClose}>İptal</Button>
            <Button onClick={handleAddShop} variant="contained" color="primary">Ekle</Button>
          </DialogActions>
        </Dialog>
        
        {/* Mağaza Düzenleme Dialog'u */}
        <Dialog open={openEditDialog} onClose={handleEditDialogClose}>
          <DialogTitle>Mağazayı Düzenle</DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              margin="dense"
              name="shopName"
              label="Mağaza Adı"
              type="text"
              fullWidth
              variant="outlined"
              value={currentShop.shopName}
              onChange={handleInputChange}
            />
            <FormControl fullWidth margin="dense">
              <InputLabel id="edit-status-select-label">Durum</InputLabel>
              <Select
                labelId="edit-status-select-label"
                id="edit-status-select"
                name="status"
                value={currentShop.status}
                label="Durum"
                onChange={handleInputChange}
              >
                <MenuItem value="active">Aktif</MenuItem>
                <MenuItem value="inactive">Pasif</MenuItem>
              </Select>
            </FormControl>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleEditDialogClose}>İptal</Button>
            <Button onClick={handleUpdateShop} variant="contained" color="primary">Güncelle</Button>
          </DialogActions>
        </Dialog>
        
        {/* Mağaza Silme Dialog'u */}
        <Dialog open={openDeleteDialog} onClose={handleDeleteDialogClose}>
          <DialogTitle>Mağazayı Sil</DialogTitle>
          <DialogContent>
            <DialogContentText>
              "{currentShop.shopName}" mağazasını silmek istediğinize emin misiniz? Bu işlem geri alınamaz.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleDeleteDialogClose}>İptal</Button>
            <Button onClick={handleDeleteShop} variant="contained" color="error">Sil</Button>
          </DialogActions>
        </Dialog>
        
        {/* Bildirim Snackbar'ı */}
        <Snackbar 
          open={snackbar.open} 
          autoHideDuration={6000} 
          onClose={handleSnackbarClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        >
          <Alert onClose={handleSnackbarClose} severity={snackbar.severity} sx={{ width: '100%' }}>
            {snackbar.message}
          </Alert>
        </Snackbar>
      </Container>
    );
  };

  return (
    <>
      <Snackbar
        open={alertOpen}
        autoHideDuration={6000}
        onClose={() => setAlertOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={() => setAlertOpen(false)} severity={alertSeverity}>
          {alertMessage}
        </Alert>
      </Snackbar>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          // Artık sabit yükseklik kullanmıyoruz.
          // height: "100vh",
          minHeight: "100vh", // sayfa boyu kadar arkaplanın uzaması için
          bgcolor: "rgb(180, 190, 190)",
          p: 2,
          overflow: "auto",
        }}
      >
        <Box sx={{ display: "flex" }}>
          <CssBaseline />
          <AppBar
            position="fixed"
            open={open}
            style={{ backgroundColor: "#405D72" }}
          >
            <Toolbar style={{ backgroundColor: "#405D72" }}>
              <IconButton
                color="inherit"
                aria-label="open drawer"
                onClick={handleDrawerOpen}
                edge="start"
                sx={[
                  {
                    mr: 2,
                  },
                  open && { display: "none" },
                ]}
              >
                <MenuIcon />
              </IconButton>
              <Typography variant="h6" noWrap component="div">
                Bakım Ekranları
              </Typography>
              <IconButton
  onClick={() => navigate("/")}
  sx={{
    display: "flex",  // İçindeki elemanları yan yana hizalar
    alignItems: "center",  // Dikey hizalamayı ortalar
    gap: 1,  // Avatar ile metin arasına boşluk ekler
    padding: "5px 15px", // İç boşluk ayarı
    borderRadius: "25px", // Oval buton şekli
    backgroundColor: "#fff",
    ml: "auto", // En sağa yaslamak için
    "&:hover": {
      backgroundColor: "#ccc",
    },
  }}
>
  <Avatar
    src="/Logos/HORSE HEAD.svg"
    alt="Ana Menü"
    sx={{ width: 50, height: 50 }}
  />
  <Typography
    variant="h6"
    sx={{
      fontWeight: "bold",  // Kalın yazı tipi
      color: "#000",  // Siyah renk
    }}
  >
    Ana Menü
  </Typography>
</IconButton>
            </Toolbar>
          </AppBar>
          <Drawer
            sx={{
              width: drawerWidth,
              flexShrink: 0,
              "& .MuiDrawer-paper": {
                width: drawerWidth,
                boxSizing: "border-box",
                backgroundColor: "#DDE7F2",
              },
            }}
            variant="persistent"
            anchor="left"
            open={true}
          >
            <Toolbar>
              <IconButton onClick={handleDrawerClose}>
                {<ChevronLeftIcon />}
              </IconButton>
            </Toolbar>
            <Divider />
            <List>
              {[
                { text: "Kullanıcı Yetkileri", icon: <SecurityIcon /> },
                { text: "Kullanıcı Shop Eşleştirme", icon: <StoreIcon /> },
                {
                  text: "Kullanıcı Hiyerarşi Tanımlama Ekranı",
                  icon: <AccountTreeIcon />,
                },
                {
                  text: "Kullanıcı Ücret Tanımlama Ekranı",
                  icon: <AttachMoneyIcon />,
                },
                {
                  text: "Diğer Ücretler Tanımlama Ekranı",
                  icon: <ReceiptIcon />,
                },
                {text: "Sunucu Kullanıcı Eşleştirme", icon: <ReceiptIcon />},
                {text: "Mağaza Düzenleme Paneli", icon: <ReceiptIcon />},
              ].map(({ text, icon }, index) => (
                <ListItem key={text} disablePadding>
                  <ListItemButton onClick={() => handleMenuClick(text)}>
                    <ListItemIcon>{icon}</ListItemIcon>
                    <ListItemText primary={text} />
                  </ListItemButton>
                </ListItem>
              ))}
            </List>
            <Divider />
          </Drawer>
          <Box component="main" sx={{ flexGrow: 1, p: 3, maxHeight: "100vh" }}>
            <Toolbar />
            {/* Menüye göre dinamik içerik */}
            {selectedMenu === "Kullanıcı Yetkileri" && (
              <Typography>
             
                {user.Admin === 1  ? <UserStatusTable /> : "Yetkiniz yok!"}
              </Typography>
            )}
            {selectedMenu === "Kullanıcı Shop Eşleştirme" && (
              <Typography>
               
                {user.Admin === 1  ? <UserShopMatch userData={userData} shopData={shopdata} /> : "Yetkiniz yok!"}
              </Typography>
            )}
            {selectedMenu === "Kullanıcı Hiyerarşi Tanımlama Ekranı" && (
              <Typography>
               
                {user.Admin === 1  ?  <UserHierarchy userData={userData} /> : "Yetkiniz yok!"}
              </Typography>
            )}
            {selectedMenu === "Kullanıcı Ücret Tanımlama Ekranı" && (
              <Typography>
              
                {user.Admin === 1  ? <UserEffortManagement /> : "Yetkiniz yok!"}
              </Typography>
            )}
            {selectedMenu === "Diğer Ücretler Tanımlama Ekranı" && (
              <Typography>
                {user.Admin === 1 || user.Username === "osman kale" || user.Username === "ibrahim bagdes"  ?  <ShopExpenses /> : "Yetkiniz yok!"}
              </Typography>
            )}
            {selectedMenu === "Sunucu Kullanıcı Eşleştirme" && (
              <Typography>
               
                {user.Admin === 1 ?  <ScreenShotAuth /> : "Yetkiniz yok!"}
              </Typography>
            )}
            {selectedMenu === "Mağaza Düzenleme Paneli" && (
              <Typography>
                {user.Admin === 1  ? <ShopManagementPanel /> : "Yetkiniz yok!"}
              </Typography>
            )}
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default MaintenanceScreen;
